// SectionHero.js
import React, { useMemo } from 'react';
import { SecondaryButton } from '../../../components';
import css from './SectionHero.module.css';

import { useHistory, useLocation } from 'react-router-dom';
import { useIntl } from '../../../util/reactIntl';

import { useConfiguration } from '../../../context/configurationContext';
import { useRouteConfiguration } from '../../../context/routeConfigurationContext';

import { AUCTIONS_SEARCH_PARAMS, isMainSearchTypeKeywords, isOriginInUse } from '../../../util/search';
import { createResourceLocatorString } from '../../../util/routes';
import {
  DEFAULT_LISTING_CREATION_PATH,
  getCreateListingRedirectTarget,
} from '../../../util/sellerVerification';
import TopbarSearchForm from '../../TopbarContainer/Topbar/TopbarSearchForm/TopbarSearchForm';
import { getSearchPageResourceLocatorStringParams } from '../../SearchPage/SearchPage.shared';

function SectionHero(props) {
  const { useHistoryPush, viewport, currentUser } = props;

  const intl = useIntl();
  const config = useConfiguration();
  const routeConfiguration = useRouteConfiguration();

  const history = useHistory();
  const location = useLocation();

  const isMobileLayout = viewport?.width > 0 && viewport?.width < 768;

  // Hero is typically on LandingPage, so initial values can be empty.
  // If your marketplace uses keywords search, we still pass the right shape.
  const initialSearchFormValues = useMemo(() => {
    return isMainSearchTypeKeywords(config) ? { keywords: '' } : { location: null };
  }, [config]);

  const handleHeroSearchSubmit = values => {
    const topbarSearchParams = () => {
      if (isMainSearchTypeKeywords(config)) {
        const raw = values?.keywords;
        const trimmed = typeof raw === 'string' ? raw.trim() : '';
        return trimmed ? { keywords: trimmed } : {};
      }

      const v = values?.location;
      const search = v?.search;
      const selectedPlace = v?.selectedPlace;

      const origin = selectedPlace?.origin;
      const bounds = selectedPlace?.bounds;

      const originMaybe = isOriginInUse(config) && origin ? { origin } : {};

      // If no location typed/selected, don't push empty params
      if (!search && !bounds && !origin) {
        return {};
      }

      return {
        ...originMaybe,
        ...(search ? { address: search } : {}),
        ...(bounds ? { bounds } : {}),
      };
    };

    const searchParams = {
      ...topbarSearchParams(),
    };

    const { routeName, pathParams } = getSearchPageResourceLocatorStringParams(
      routeConfiguration,
      location
    );

    history.push(
      createResourceLocatorString(routeName, routeConfiguration, pathParams, searchParams)
    );
  };

  const handleStartSelling = () => {
    const target = getCreateListingRedirectTarget(currentUser, DEFAULT_LISTING_CREATION_PATH);
    const path = createResourceLocatorString(
      target.name,
      routeConfiguration,
      target.params || {},
      {}
    );

    history.push(`${path}${target.to?.search || ''}`);
  };


  return (
    <div className={css.heroSection}>
      <div className={css.heroContent}>
        <span>{intl.formatMessage({ id: 'SectionHero.brand' })}</span>

        <h1>{intl.formatMessage({ id: 'SectionHero.title' })}</h1>

        <p>{intl.formatMessage({ id: 'SectionHero.subtitle' })}</p>

        <div className={css.lookingForSec}>
          <SecondaryButton role="button" onClick={handleStartSelling}>
            {intl.formatMessage({ id: 'SectionHero.sellBarrel' })}
          </SecondaryButton>

          <SecondaryButton
            role="button"
            onClick={() => useHistoryPush('SearchPage', {}, AUCTIONS_SEARCH_PARAMS)}
          >
            {intl.formatMessage({ id: 'SectionHero.browseAuctions' })}
          </SecondaryButton>

          <SecondaryButton role="button" onClick={() => useHistoryPush('SearchPage')}>
            {intl.formatMessage({ id: 'SectionHero.exploreDistilleries' })}
          </SecondaryButton>
        </div>

        <TopbarSearchForm
          className={css.searchSec}
          desktopInputRoot={css.topbarSearchWithLeftPadding}
          onSubmit={handleHeroSearchSubmit}
          initialValues={initialSearchFormValues}
          isMobile={isMobileLayout}
          appConfig={config}
        />

        <p className={css.footerText}>
          {intl.formatMessage({ id: 'SectionHero.footerText' })}{' '}
          {/* <span role="button" onClick={() => useHistoryPush('CMSPage', { pageId: 'about' })}>
            {intl.formatMessage({ id: 'SectionHero.learnMore' })}
          </span> */}
        </p>
      </div>
    </div>
  );
}

export default SectionHero;
